<template>
  <div class="field">
    <label class="label" v-if="label">{{ label }}</label>
    <div class="control">
      <div
        class="dropdown"
        :class="{ 'is-active': isActive }"
        v-click-outside="close"
      >
        <div class="dropdown-trigger">
          <button class="button" @click="toggle" :disabled="disabled">
            <span v-if="!!icon" class="icon has-text-grey-lighter">
              <i :class="icon"></i>
            </span>
            <span class="dropdown-title">{{ $t(dropdownTitle) }}</span>
            <span class="icon trigger is-small">
              <i class="fa fa-angle-down"></i>
            </span>
          </button>
        </div>
        <div class="dropdown-menu">
          <div class="dropdown-content">
            <label
              class="dropdown-item"
              v-for="(option, idx) in options"
              :key="idx"
            >
              <input
                type="checkbox"
                v-model="option.selected"
                @change="onChange(option)"
              />
              {{ option.text || option.value }}
            </label>
            <label
              class="dropdown-item"
              v-if="!options || options.length == 0"
              >{{ $t("No options") }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// optionsExample = [{value: "AMZ", selected: true, text="Amazon"}, { value: "GOG", selected: true, text: "Google" }]
export default {
  name: "multiselect-field",
  props: ["value", "label", "disabled", "icon", "emptyLabel"],
  data() {
    return {
      options: this.cloneOptions(this.value),
      isActive: false
    }
  },
  watch: {
    value() {
      this.options = this.cloneOptions(this.value)
    }
  },
  computed: {
    dropdownTitle() {
      const selected = this.options.filter(option => option.selected)
      if (selected.length === 0) {
        return this.emptyLabel || "None selected"
      } else if (selected.length < 4) {
        return selected.map(option => option.text || option.value).join(", ")
      } else {
        return ["Selected {0}", selected.length]
      }
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    },
    close() {
      this.isActive = false
    },
    cloneOptions(options) {
      return options.map(e => ({
        value: e.value,
        text: e.text,
        selected: e.selected
      }))
    },
    onChange(option) {
      this.$emit("change", option)
      this.$emit("input", this.options)
    }
  }
}
</script>

<style lang="scss">
.dropdown {
  width: 100%;
  .dropdown-trigger {
    width: 100%;
    .button {
      justify-content: flex-start;
      .dropdown-title {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .icon.trigger {
        margin-left: auto !important;
      }
    }
  }
  .dropdown-menu {
    width: 100%;
  }
  .button {
    width: 100%;
  }
}
.dropdown-item {
  &:hover {
    background-color: whitesmoke;
  }
}
</style>
